import * as React from 'react';

export declare namespace Background {
	interface Props {
		src: string;
		width: number;
		height: number;
	}
}

const Background = (props: Background.Props) => (
	<div className="backgroundContainer">
		<div className="backgroundOffsetter" />
		<div style={{ width: `calc(0px - ((100vw - ${props.width}px) / 2))` }} className="backgroundPosition">
			<img className="backgroundImg" src={props.src} />
		</div>
	</div>
);

export default Background;


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Common/Background/index.tsx